<template>
  <div class="fx__hover" @mouseenter="isShow = true" @mouseleave="isShow = false" @click="routerTo($event,Menu.name)" style="transition: all 0.2s;" :class="IsFold ? 'link_change' : 'link'">
    <!-- ding按钮 -->
    <i class="fa fa-thumb-tack isShow" v-show="isShow || isDing" @click.stop="addMenus"></i>
    <div :class="[Menu.name, IsFold ? 'icon_change' : 'icon']" style="position: relative" :style="{ background: Menu.iconbg ? Menu.iconbg : '' }">
      <Badge :count="$store.state.notify.moduleNoticeNum[Menu.name]" :dot="isDing && getNum(Menu.name) > 0" style="position: absolute;
       " :style="{ top: isDing ? '6px!important' : '-5px', right: isDing ? '6px!important' : ' -3px' }"> </Badge>
      <!-- 自定义的svg -->
      <svg-icon :iconClass="Menu.svg" v-if="Menu.svg" class="item_icon fa-lg"></svg-icon>
      <!-- 自定义的icon -->
      <i v-else-if="Menu.icon" :class="Menu.icon"></i>
      <!-- 默认 -->
      <i v-else class="fa fa-circle fa-lg"></i>

    </div>
    <div class="textBox" v-show="!IsFold">
      <div class="menuText fx__text_headline fx__simpleline">{{ Menu.text }}</div>
      <div class="menuDesc fx__text_assist" :title="Menu.description">{{ Menu.description }}</div>
      <span @click.stop="openWind(Menu.name)" :class="['menuLink', 'fa fa-share-square-o fa-2x']" title="新窗口全屏打开"></span>
    </div>
    <div v-show="IsFold" :class="{ tooltip_text: IsFold }">
      <span style="color: rgb(248, 241, 241);">{{ Menu.text }}</span>
      <span class="fa fa-caret-down tooltip_icon"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Menu: Object,
    IsFold: Boolean,
    isDing: Boolean,
  },
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    getNoticeNum() {
      return (name) => {
        return this.$store.getters["notify/getNoticeNum"](name)
      }
    },

    getNum() {
      let noticeNum = this.$store.getters["notify/getRouteNum"]
      if (noticeNum) return (name) => noticeNum(name)
      else return () => 0
    },
  },
  methods: {
    openWind(name) {
      // debugger
      // let { origin, pathname, search } = window.location

      this.$app.routeMenuToBlank(name)
      // let item = this.$app.routes[0].children.find((p) => p.name == name)
      // let hash = `#/${name}`
      // if (item.path) hash = `#/${item.path}`
      // if (item.MenuParams) {
      //   //【uri.hash】可用这句话来构造：this.$router.resolve({name:"core-userManager",  query:{"ff":"ggggg"}}).href
      //   hash = this.$router.resolve({ name, path: item.path, params: item.MenuParams }).href
      //   // Object.keys(item.MenuParams).forEach(key=>{
      //   //    path =  path.replace(`:${key}`,`${item.MenuParams[key]}`)
      //   // })
      // }
      // let uri = new URL(window.location)
      // uri.hash = hash
      // uri.searchParams.set("fullscreen", "")
      // window.open(uri.href, "_blank")
      // debugger
      // let url = ""
      // if(search){
      //   if(window.QueryDict.hasOwnProperty("fullscreen")){
      //     url= `${origin}${pathname}${search}#/${path}`
      //   }else{
      //     url= `${origin}${pathname}${search}&fullscreen#/${path}`
      //   }
      // }else{
      //    url= `${origin}${pathname}?fullscreen#/${path}`
      // }
      // window.open(url);
    },
    routerTo($event, name) {
      if ($event.ctrlKey) {
        this.$app.routeMenuToBlank(name)
        return
      }
      // app.routeMenuToBlank
      this.$app.routeMenuTo(name)
    },
    addMenus() {
      this.$emit("on-ding", this.Menu)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip_text {
  position: absolute;
  display: none;
  padding: 5px;
  width: 100px;
  height: 35px;
  top: -43px;
  left: 38px;
  z-index: 3;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.6);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);

  span {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tooltip_icon {
    position: absolute;
    bottom: -9px;
    left: 10px;
    color: rgba(19, 19, 19, 0.5);
  }
}

.icon_change {
  width: 40px;
  height: 40px;
  background: -webkit-linear-gradient(left, rgb(98, 184, 102), rgb(72, 164, 76));
  background: linear-gradient(to right, rgb(98, 184, 102), rgb(72, 164, 76));
  color: #ffffff;
  border-radius: 32px;
  // animation:mychange 0.2s alternate 1;
  font-size: 15px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

// @keyframes mychange
// {
//     from {transform: rotate(60deg);}
//     to {transform: rotate(0);}
// }
// @keyframes mychange2
// {
//     from {transform: rotate(-45deg);}
//     to {transform: rotate(0);}
// }
.icon {
  width: 68px;
  height: 68px;
  background: -webkit-linear-gradient(left, rgb(98, 184, 102), rgb(72, 164, 76));
  // animation:mychange2 0.4s alternate 1;
  background: linear-gradient(to right, rgb(98, 184, 102), rgb(72, 164, 76));
  color: #ffffff;
  border-radius: 16px;
  font-size: 25px;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.link_change {
  padding: 10px;
  cursor: pointer;
  position: relative;
  margin: 0 0 10px 0;
  border-radius: 8px;

  .isShow {
    font-size: 16px;
    height: 18px;
    transform: rotate(-45deg);
    position: absolute;
    top: 0;
    left: 8px;

    &:hover {
      color: #51acfe;
    }
  }

  &:hover .tooltip_text {
    display: flex;
  }
}

.link {
  display: flex;
  width: 25%;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 0 10px 0;
  position: relative;
  padding-left: 25px;

  &:hover {
    .menuText {
      color: #51acfe;
    }
  }

  .textBox {
    position: relative;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 14px;
    width: calc(100% - 68px);

    .menuText {
      font-size: 16px;
      font-weight: bold;
    }

    &:hover {
      .menuLink {
        display: block;
      }
    }

    .menuLink {
      display: none;
      position: absolute;
      right: 0;

      &:hover {
        color: #51acfe;
      }
    }

    .menuDesc {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      max-height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .isShow {
    font-size: 24px;
    height: 30px;
    transform: rotate(-45deg);
    position: absolute;
    top: 0;
    left: 10px;

    &:hover {
      color: #51acfe;
    }
  }
}

.item_icon {
  width: 34px;
  height: 34px;
}

@media screen and (max-width: 1200px) {
  .link {
    width: 33.33%;
  }
}

@media screen and (max-width: 992px) {
  .link {
    width: 48.5%;
    padding-right: 0;
  }
}
</style>
